import { render } from "./GeneralView.vue?vue&type=template&id=0ca4fbad&scoped=true"
import script from "./GeneralView.vue?vue&type=script&lang=js"
export * from "./GeneralView.vue?vue&type=script&lang=js"

import "./GeneralView.vue?vue&type=style&index=0&id=0ca4fbad&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4fbad"]])

export default __exports__